import type {$Fetch} from "nitropack";
import baseRepository from "~/api/BaseRepository";

export const NextMissionRepository = (client: $Fetch) => ({
    async fetchNextMissionPreference(id: string) {
        return client(`/v2/users/${id}/next-mission-preference`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then((mission) => {
                return mission;
            });
    },

    async updateNextMissionPreference(id: string, data: any) {
        return client(`/v2/users/${id}/next-mission-preference`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then((mission) => {
                return mission;
            });
    }
})